import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { User } from 'src/app/models/core/user.model';

const GENERIC_CODE_UPDATE_ERROR = 'No se pudo actualizar el código.';

@Injectable({
  providedIn: 'root'
})
export class UserProfileApiServiceService {
  private baseUrl = `${environment.api_server}/api/user`;

  constructor(
    private _http: HttpClient,
    private _api: ApiService
  ) {}

  public getProfile(): Observable<User> {
    const url = `${this.baseUrl}/profile`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<{ data: User }>(url, { headers })
      ),
      switchMap(response => [response.data])
    );
  }

  public updateProfile(data: Partial<Record<keyof User, string | null>>): Observable<User> {
    const url = `${this.baseUrl}/profile`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.put<{ data: User }>(url, data, { headers })
      ),
      switchMap(response => [response.data])
    );
  }

  public updateCode(code: string): Observable<User> {
    const url = `${this.baseUrl}/profile/code`;
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.put<{ data: User }>(url, { code }, { headers })
      ),
      switchMap(response => [response.data]),
      catchError(error => throwError(() => this.toCodeUpdateError(error)))
    );
  }

  private toCodeUpdateError(error: HttpErrorResponse): Error {
    const fieldMessage = error?.error?.errors?.code?.[0];
    return new Error(fieldMessage ?? error?.error?.message ?? GENERIC_CODE_UPDATE_ERROR);
  }
}
